/** Grymwyrd deutscher Text für das gemeinsame Layout (TopNav + Footer). */
export const layoutDe = {
  'layout.nav.veil': 'Der Schleier',
  'layout.nav.encyclopedia': 'Enzyklopädie',
  'layout.nav.world': 'Die Welt',
  'layout.nav.play': 'Spielen',
  'layout.nav.books': 'Bücher & Regeln',
  'layout.nav.community': 'Gemeinschaft',
  'layout.nav.homeAria': 'Startseite von {world}',
  'layout.nav.search': 'Enzyklopädie durchsuchen',
  'layout.nav.unmute': 'Atmosphäre einschalten',
  'layout.nav.mute': 'Atmosphäre stummschalten',
  'layout.nav.coinBalance': 'Münzguthaben',
  'layout.nav.signedInAs': 'Angemeldet als {name}',
  'layout.nav.enter': 'Betritt {world}',
  'layout.nav.toggleMenu': 'Menü umschalten',
  'layout.nav.dashboard': 'Mein {world} ({name})',
  'layout.nav.signOut': 'Abmelden',

  'layout.footer.hideLinks': 'Seitenlinks ausblenden',
  'layout.footer.showLinks': 'Seitenlinks & Rechtliches',
  'layout.footer.tagline': 'Die lebendige Horror-Fantasy-Welt, in der deine Legende zum Kanon wird.',
  'layout.footer.explore': 'Entdecken',
  'layout.footer.legal': 'Rechtliches',
  'layout.footer.accessibility': 'Barrierefreiheit',
  'layout.footer.encyclopedia': 'Enzyklopädie',
  'layout.footer.world': 'Die Welt',
  'layout.footer.playVtt': 'Spielen (VTT)',
  'layout.footer.books': 'Bücher & Regeln',
  'layout.footer.terms': 'Nutzungsbedingungen',
  'layout.footer.privacy': 'Datenschutzerklärung',
  'layout.footer.canonRelease': 'Einwilligung zur Kanon-Einreichung',
  'layout.footer.aiPolicy': 'KI-Richtlinie',
  'layout.footer.cookies': 'Cookie-Einstellungen',
  'layout.footer.copyright': '© 2026 GameCodex',
}
